/**
 * File: useNavItemController.ts
 * Path: apps/admin/src/modules/layout/hooks/useNavItemController.ts
 * Description: Whether one sidebar link is lit for the page being shown.
 */

import { useNavActiveState } from "@/modules/layout/hooks/useNavActiveState";

export const useNavItemController = (href: string | undefined) => ({
  isActive: useNavActiveState().isActive(href),
});
